import { SvgKey } from "../../assets/icons/index";
import { ResetPasswordFormType } from "../../models/forms/resetPasswordForm";
import { useState } from "react";
import { WithIconTextAreaFormInputForResetPassword } from "../generic/forms/WithIconTextAreaFormInputForResetPassword";
type IResetPasswordForm = {
  formValue: ResetPasswordFormType;
};
export const ResetPasswordForm = (props: IResetPasswordForm) => {
  const { formValue } = props;

  const [hasError, setHasError] = useState<boolean>(false);
  const [passwordMatchError, setPasswordMatchError] = useState<boolean>(false);

  const newPassWordSetOnFocus = () => {
    errorHandler(true);
  };

  const newPassWordSetOnBlur = () => {
    errorHandler(false);
  };

  const isValidated = (password: string) => {
    const hasAtLeastOneCapLetter = /[A-Z]/.test(password ?? "");
    const hasAtLeastOneNumber = /[0-9]/.test(password ?? "");
    const minPasswordLength = 8;
    if (
      password.length < minPasswordLength ||
      !hasAtLeastOneCapLetter ||
      !hasAtLeastOneNumber
    ) {
      return false;
    } else {
      return true;
    }
  };
  const errorHandler = (isFocused: boolean) => {
    if (formValue.NewPassword !== undefined) {
      if (!isFocused && !isValidated(formValue.NewPassword)) {
        setHasError(true);
      } else {
        setHasError(false);
      }
    }
  };
  return (
    <div className="d-flex flex-column align-items-center">
      <WithIconTextAreaFormInputForResetPassword
        className="ms-2 p-0 w-100 me-2 mt-3"
        name="NewPassword"
        type="password"
        onBlurFunc={newPassWordSetOnBlur}
        onFocusFunc={newPassWordSetOnFocus}
        errorText={
          hasError
            ? " Password must be at least 8 characters (at least 1 number and 1 capital letter)"
            : ""
        }
        showError={hasError}
        placeholder="New Password"
        svgicon={SvgKey}
      />
      <WithIconTextAreaFormInputForResetPassword
        className="ms-2 p-0 w-100 me-2 mt-3"
        name="ConfirmNewPassword"
        type="password"
        onBlurFunc={() => {
          if (formValue.NewPassword !== formValue.ConfirmNewPassword) {
            setPasswordMatchError(true);
          } else {
            setPasswordMatchError(false);
          }
        }}
        onFocusFunc={() => {
          setPasswordMatchError(false);
        }}
        errorText={
          passwordMatchError
            ? "Password & Confirm Password does not match."
            : ""
        }
        showError={passwordMatchError}
        placeholder="Confirm Password"
        svgicon={SvgKey}
      />
    </div>
  );
};
